// extracted by mini-css-extract-plugin
export default {"label":"Select_label__pLTxb","input":"Select_input__TBJ-U"};